import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateEstimateLineItemInput,
  UpdateEstimateLineItemMutation as UpdateEstimateLineItemMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const UpdateEstimateLineItemMutation = graphql(`
  mutation UpdateEstimateLineItem($input: UpdateEstimateLineItemInput!) {
    updateEstimateLineItem(input: $input) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
      }
    }
  }
`);

const useUpdateEstimateLineItem = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    UpdateEstimateLineItemMutationResult,
    Error,
    UpdateEstimateLineItemInput
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<
    UpdateEstimateLineItemMutationResult,
    Error,
    UpdateEstimateLineItemInput
  >({
    mutationFn: (input) => {
      return gqlClient.request(UpdateEstimateLineItemMutation, { input });
    },
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.updateEstimateLineItem,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUpdateEstimateLineItem;
